var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_5313)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#00483D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_446_5313)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_446_5313",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V1024H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V1024H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.5,
    cy: 920,
    rx: 305.5,
    ry: 306,
    fill: "#00E7C4",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1096.5,
    cy: 904,
    rx: 305.5,
    ry: 306,
    fill: "#00E7C4",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.5,
    cy: 213.5,
    rx: 329.5,
    ry: 330.5,
    fill: "#00E7C4",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1294.5,
    cy: 191.5,
    rx: 329.5,
    ry: 330.5,
    fill: "#00E7C4",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1439 0V1024H1441V0H1439Z",
    fill: "#F2F4F7",
    mask: "url(#path-1-inside-1_446_5313)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_5313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_446_5313"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V1024H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroVerify);
export default __webpack_public_path__ + "static/media/heroVerify.70cdb3d28cba0fe769d44c74c5bbfad9.svg";
export { ForwardRef as ReactComponent };